
import React from 'react';
import { Conversation, User, Language, AppMode } from '../types';
import SidebarHeader from './Sidebar/SidebarHeader';
import SidebarList from './Sidebar/SidebarList';
import SidebarFooter from './Sidebar/SidebarFooter';

interface SidebarProps {
  conversations: Conversation[];
  currentId: string | null;
  onSelect: (id: string) => void;
  onNewChat: () => void;
  onDelete: (id: string) => void;
  onClearAll?: () => void;
  onOpenSettings: () => void;
  onOpenPlans: () => void;
  onSwitchMode: (mode: AppMode) => void;
  theme: 'light' | 'dark';
  toggleTheme: () => void;
  isOpen: boolean;
  onClose: () => void;
  user: User;
  onLogout?: () => void;
  language: Language;
  onSwitchLanguage: (lang: Language) => void;
}

const Sidebar: React.FC<SidebarProps> = ({
  conversations, currentId, onSelect, onNewChat, onDelete, onClearAll,
  onOpenSettings, onOpenPlans, onSwitchMode, isOpen, onClose, user,
  onLogout, language, onSwitchLanguage
}) => {
  const isRtl = language === 'ar';

  return (
    <>
      <div className={`fixed inset-0 bg-black/60 backdrop-blur-md z-[60] lg:hidden transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} />
      
      <aside className={`
        fixed inset-y-0 ${isRtl ? 'right-0' : 'left-0'} z-[60] w-[85vw] sm:w-80 lg:w-72 bg-white dark:bg-[#0a0a0c] border-${isRtl ? 'l' : 'r'} border-slate-100 dark:border-white/5 
        flex flex-col transform transition-transform duration-500 ease-[cubic-bezier(0.4,0,0.2,1)] lg:translate-x-0 lg:static
        ${isOpen ? 'translate-x-0' : (isRtl ? 'translate-x-full' : '-translate-x-full')}
      `}>
        
        <SidebarHeader 
          user={user} 
          isRtl={isRtl} 
          language={language}
          onNewChat={() => { onNewChat(); onSwitchMode('chat'); onClose(); }}
          onClose={onClose}
        />

        <SidebarList 
          conversations={conversations}
          currentId={currentId}
          language={language}
          onSelect={onSelect}
          onSwitchMode={onSwitchMode}
          onClose={onClose}
          onDelete={onDelete}
          onClearAll={onClearAll || (() => {})}
        />

        <SidebarFooter 
          language={language}
          onOpenPlans={onOpenPlans}
          onSwitchLanguage={onSwitchLanguage}
          onOpenSettings={onOpenSettings}
          onLogout={onLogout || (() => {})}
          onClose={onClose}
        />

      </aside>
    </>
  );
};

export default Sidebar;
